export default __webpack_public_path__ + "static/media/chainTransparent.e6491891.png";